import React, {
  useState,
  useEffect,
  useRef,
  Fragment,
  memo,
  useMemo,
  useCallback
} from "react";
import { createPortal, unmountComponentAtNode } from "react-dom";
import styles from "./index_1.module.css";
import Impetus from "./Impetus";
// import MSE from './mse'
// import MSEL from './mseL'
import Bin from "./bin/bin";
import Utils, { clearSelection, pushGTMData, pushGTMExtraData } from "./utils";
import { R2pSlider } from "./slider/slider-ja";
import { BnSlider } from "./slider/slider-bn";
import { settings } from "./settings";
import {
  BnIcon,
  TouchMaskBNSVG,
  MouseMaskBNSVG,
  TouchMaskJASVG,
  MouseMaskJASVG
} from "./icons/bn";
import { JaIcon } from "./icons/ja";

export const PlayerSocket = Utils.PlayerSocket;
export const PlayerSync = Utils.PlayerSync;
export const PlayerRemote = Utils.PlayerRemote;
export const PlayerSettings = settings;

export const VideoPlayerComp = (props) => {
  const r2p = props.r2pData;
  const isPair = !!r2p.isPair;

  if (r2p.startWithImg) {
    r2p.autoplay = true;
  }
  r2p.preload = !r2p.autoplay && !r2p.preloadAll;
  const scale = r2p.scale || 0;

  const isStone = props.isStone;

  if (r2p.displayType) {
    const settings = PlayerSettings[r2p.displayType];
    r2p.direction = settings.invertRotate ? -1 : 1;
  }

  r2p.maxImages = r2p.isMobile
    ? isStone
      ? [256]
      : [128, 192]
    : isStone
    ? [256]
    : [384];

  if (!r2p.urlFormat) {
    return (
      <img
        {...(r2p.alt ? { alt: r2p.alt } : {})}
        src={r2p.poster}
        style={{ verticalAlign: "middle", width: `${100 + scale}%` }}
      />
    );
  }
  let _settings;
  if (r2p.displayType) {
    _settings = settings[r2p.displayType];
  }

  const initialLoad = r2p.initialLoad || 2;
  const settingsLoadLength =
    _settings && _settings.server && _settings.server.setsNum;

  const loadLength = r2p.forceTotal || r2p.setsNum || settingsLoadLength || 12;
  const restLoad = loadLength - initialLoad > 0 ? loadLength - initialLoad : 0;
  r2p.load = r2p.load || [initialLoad, restLoad];
  const setsNum = useRef(loadLength);
  r2p.preloadNum = r2p.load[0];
  const [showLoader, setShowLoader] = useState(false);
  const [debugOn, setDebugOn] = useState(r2p.debugOn);
  const [showFinger, setShowFinger] = useState(false);

  useEffect(
    (_) => {
      if (debugOn) {
        const { realPos, imgPos } = _Bin.current;
        setDebugPos({ realPos, imgPos });
      }
    },
    [debugOn]
  );

  const psync = useRef(r2p.playerSync || {});
  const inViewTimer = useRef(false);
  const multiplier = useRef([]);
  const mouseDounNum = useRef(0);
  const idleSpeed = useRef([]);
  const playerLength = useRef(0);
  const inView = useRef(false);
  const currentSet = useRef(0);
  const scrollTime = useRef(0);
  const lastSet = useRef(0);
  const msEdited = useRef();
  const mask = useRef();
  const handClicked = useRef(false);
  const loadPhase = useRef(0);
  const isOnTop = useRef(false);
  const isClient = typeof window !== "undefined";
  const isTouch = useRef(
  isClient && r2p.isTouch !== undefined
    ? r2p.isTouch
    : ("ontouchstart" in window && navigator.maxTouchPoints > 0)
  );
  const handDelay = useRef(false);
  const playerStarted = useRef(false);
  const isPaused = useRef(false);
  const isCanvas = useRef(false);
  const updateN = useRef(1);
  const lastPhase = useRef(0);
  const isPlayerInit = useRef(false);
  const timerIdInterval = useRef(false);
  const isMouseDown = useRef(!r2p.autoplay);
  const _Bin = useRef(false);
  const videoEl = useRef(null);
  const videoElR = useRef(null);
  const debugEl = useRef(null);
  const log1El = useRef(null);
  const log2El = useRef(null);
  const log5El = useRef(null);
  const bbEl = useRef(null);
  const baEl = useRef(null);
  const playerDirection = useRef(r2p.direction || 1);
  const _direction = useRef(1);
  const drawImg = useRef(null);
  const drawPos = useRef(null);
  const b0El = useRef(null);
  const blEl = useRef(null);
  const logsEl = useRef(null);
  const playpauseEl = useRef(null);
  const dupliEl = useRef(null);
  const contEl = useRef(null);
  const canvasEl = useRef(null);
  const imgBgContainerEl = useRef();
  const canvasContainerEl = useRef(null);
  const playerMaskEl = useRef(null);
  const i360El = useRef(null);
  const rpProgressEl = useRef(null);
  const imp = useRef(null);
  const setSliderPos = useRef(null);
  const setShowSlider = useRef(null);
  const imgbgEl = useRef(null);
  const imgHideEl = useRef(null);

  const s = styles;
  const Loader = props.Loader || ((_) => <div className={s.loader}></div>);

  const isSecond = useRef(r2p.PlayerSocket && props.r2pData.isSecond);

  r2p.hasSecond = r2p.PlayerSocket && !isSecond.current;

  let poster = props.r2pData.poster;

  var getUrlParameter = isClient
    ? (name) => {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
        var results = regex.exec(location.search);
        return results === null
          ? ""
          : decodeURIComponent(results[1].replace(/\+/g, " "));
      }
    : (_) => "";

  let _dics_,
    mmbe,
    fileType,
    id1,
    id2,
    timerIdTimeout,
    file,
    folder,
    inImp,
    getN,
    mime,
    segment,
    disType,
    prevFrame,
    startX,
    lastTime,
    lastX,
    _last_x,
    _x,
    _delta,
    compare,
    accFrames,
    currentIndex,
    lastStepsFromStart,
    movedTo,
    iOS,
    gap,
    frameSeek,
    msel,
    moveSpeed,
    partN,
    hd,
    screenWidth = isClient ? screen.width : 0,
    isBin,
    frame = 1 / 25,
    mp4 = `video/mp4; codecs="avc1.64001f"; profiles="iso6,mp41"`,
    vp9 = 'video/webm; codecs="vp9"',
    ppId = "playpause_" + r2p.key,
    video = videoEl.current,
    isSlow = hd && hd <= 4,
    dics1 = [],
    dics2 = [],
    dics3 = [];

  prevFrame =
    startX =
    lastTime =
    lastX =
    _last_x =
    _x =
    _delta =
    compare =
    accFrames =
    currentIndex =
    lastStepsFromStart =
    movedTo =
    getN =
      0;
  moveSpeed = partN = 1;
  iOS = msel = false;
  _dics_ = dics1;

  let inSlowDown = false;

  const r2pData = props.r2pData || {};
  let { isBase64 } = r2pData;
  if (!!~r2pData.urlFormat.indexOf(".txt")) {
    isBase64 = true;
    r2pData.isBase64 = true;
  } else /*if (!!~r2pData.urlFormat.indexOf(".bin"))*/ {
    isBin = true;
    r2pData.isBin = true;
  }

  isCanvas.current = isBin || isBase64;

  let isMobile = r2p.isMobile;

  if (!isMobile && isClient) {
    isMobile =
      getUrlParameter("mobile") !== ""
        ? +getUrlParameter("mobile")
        : props.isMobile ||
          /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }

  function firstDrawHandler() {
    imgBgContainerEl.current && (imgBgContainerEl.current.style.opacity = 0);
  }

  function setMask() {
    if (isSecond.current) {
      r2p.PlayerSocket.registerLoadRest(loadRest);
    } else {
      mask.current =
        r2p.PlayerSocket && isTouch.current && r2p.PlayerSocket.maskEl
          ? r2p.PlayerSocket.maskEl.current
          : playerMaskEl.current;
      r2p.PlayerSocket &&
        isTouch.current &&
        (mask.current.style.height =
          contEl.current.getBoundingClientRect().height + "px");
      // mask.current.style.backgroundColor = getRandomColor();
      // mask.current.style.opacity = .4

      isTouch.current
        ? mask.current.addEventListener("touchstart", (e) => {
            isMouseDown.current = true;
            e.preventDefault();
          })
        : mask.current.addEventListener("mousedown", (e) => {
            clearSelection();
            document.body.style.userSelect = "none";
            isMouseDown.current = true;
            e.preventDefault();
          });

      r2p.preload &&
        mask.current.addEventListener(
          isTouch.current ? "touchstart" : "mousedown",
          loadRest
        );
      r2p.preloadAll &&
        mask.current.addEventListener(
          isTouch.current ? "touchstart" : "mousedown",
          startBinPlayer
        );
    }

    if (r2p.PlayerSocket && !isTouch.current) {
      contEl.current.addEventListener("mouseenter", (e) => {
        contEl.current.appendChild(r2p.PlayerSocket.mask);
      });
    } else if (r2p.PlayerSocket && isTouch.current) {
      contEl.current.addEventListener("touchstart", (e) => {
        contEl.current.appendChild(r2p.PlayerSocket.mask);
      });
    }
  }

  useEffect(() => {
    if (!isSecond.current) {
      setPlayPause();
    }
  }, [debugOn]);

  const replaceImageByCanvas = useCallback(() => {
    const img = imgbgEl.current;
    const canvas = canvasEl.current;
    if (!canvas) return;
    const context = canvas.getContext("2d");
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    context.drawImage(img, 0, 0, canvas.width, canvas.height);
  }, []);

  useEffect(() => {
    if (r2p.renderPoster !== false && r2p.hidePoster !== true) {
      imgHideEl.current.src = r2p.poster;
      imgHideEl.current.addEventListener("load", replaceImageByCanvas);
    }

    if (!window.fingerShowed) {
      window.fingerShowed = [];
    }
    const csrPrefix = r2p.isCsr ? "csr_" : "";
    !window[csrPrefix + "r2pStyleUse"] && styles;
    window[csrPrefix + "r2pStyleUse"] = true;

    !window.r2pStyleUse && styles;
    window.r2pStyleUse = true;
    setMask();
    if (r2p.PlayerSocket) {
      r2p.PlayerSocket.incPlayersNum();
    }
    setUrlParams(props);
    lastPhase.current = isMobile ? 2 : 3;
    hd = !isCanvas.current ? window.navigator.hardwareConcurrency || 8 : 8;

    setEvents();

    if (r2p.hasSecond) {
      r2p.PlayerSocket.mask = playerMaskEl.current;
    }

    if (!r2p.holdLoad) {
      loadPlayer(isBase64, isBin);
    }

    if (r2p.playerSync) {
      r2p.playerSync.sync({
        lock: (_) => (_ ? imp.current.pause() : imp.current.resume()),
        setPlayPause: playPause,
        direction: (_) => (_ ? (_direction.current = _) : _direction.current),
        setSliderPos: setSliderPos.current,
        setShowSlider: setShowSlider.current,
        setImg: _Bin.current.drawPos,
        getImg: (_) => _Bin.current.realPos,
        canvas: canvasEl.current
      });
    }

    contEl.current.classList.add(isTouch.current ? s.isTouch : s.noTouch);
    setRemote();

    return () => {
      timerIdTimeout && clearTimeout(timerIdTimeout);
      timerIdTimeout = null;
      timerIdInterval.current && clearInterval(timerIdInterval.current);
      timerIdInterval.current = null;
      delete window.isPlayerOn;
      window.removeEventListener("mouseup", endE);
      window.removeEventListener("scroll", handleScrollR2p);
      imp.current && imp.current.destroy();
      _Bin.current && _Bin.current.destroy();
    };
  }, []);

  const setRemote = function setRemote() {
    if (r2p.remote) {
      r2p.remote.sync({
        lock: (_) => (_ ? imp.current.pause() : imp.current.resume()),
        setPlayPause: playPause,
        setShowSlider: setShowSlider.current,
        setImg: _Bin.current.drawPos,
        getImg: (_) => _Bin.current.realPos,
        canvas: canvasEl.current
      });
    }
  };

  useEffect(() => {
    if (props.isOnTop === undefined) return;
    isOnTop.current = props.isOnTop;
    r2p.isMouseEnterPlay &&
      isPaused.current &&
      isOnTop.current &&
      !isPlayerInit.current &&
      loadPlayer(isBase64, isBin);
    isPaused.current = !isOnTop.current;
    r2p.isScrollPlay && handleScrollR2p({ fromProp: true });
  }, [props.isOnTop]);

  function setSetsNum(N) {
    setsNum.current = N;
    debugEl.current &&
      (debugEl.current.querySelector(
        ".sets"
      ).innerText = `${currentSet.current}/${setsNum.current}`);
  }

  function setSliderPosFunc(f) {
    setSliderPos.current = f;
  }

  function setShowSliderFunc(f) {
    setShowSlider.current = f;
  }

  function loadPlayer(isBase64, isBin) {
    console.log("player load : " + r2p.canvasKey);
    //inView.current = true;

    isPlayerInit.current = true;
    !isSecond.current && setImptus();
    if (isBase64) {
      loadBase64(props);
    } else if (isBin) {
      loadBin(props);
    }
  }

  function getLoadData() {
    const { notifyImgLoaded } = psync.current;
    return {
      contEl: contEl.current,
      styles,
      imgBg: imgBgContainerEl.current,
      isSecond: isSecond.current,
      r2pData: { ...r2pData },
      firstDrawHandler,
      checkWarnings,
      setDebugPos,
      setLoadedData,
      firstPhaseLoaded,
      setSetsNum,
      startBinPlayer,
      updateBinPlayer,
      log,
      log2El,
      canvas: canvasEl.current,
      showLoader: _showLoader,
      notifyImgLoaded,
      playPause
    };
  }

  function loadBase64() {
    const b = new Bin(getLoadData());
    _Bin.current = b;
    drawImg.current = b.drawImg;
    drawPos.current = b.drawPos;
  }

  function loadBin() {
    const b = new Bin(getLoadData());
    _Bin.current = b;

    if (isSecond.current) {
      r2p.PlayerSocket.syncPosFunc.push(b.drawPos);
    }

    drawImg.current = b.drawImg;
    drawPos.current = b.drawPos;
  }

  function loadRest(e) {
    isShowFinger() && incrementFinger();
    if (loadPhase.current === 1) {
      mask.current && mask.current.removeEventListener("mousedown", loadRest);
      mask.current && mask.current.removeEventListener("touchstart", loadRest);
      _Bin.current.loadRest();
    }
    handClicked.current = true;
    if (r2p.hasSecond) {
      r2p.PlayerSocket.notifyLoadRest();
    }
  }

  function isfireFoxMobile() {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
    var isAndroid = navigator.userAgent.toLowerCase().indexOf("mobile") > -1;
    return isFirefox && isAndroid;
  }

  function debugChange(e) {
    var ms = +e.target.innerText;
    if (!isNaN(ms) && ms > 9) {
      msEdited.current = ms;
      if (timerIdInterval.current) {
        clearInterval(timerIdInterval.current);
        timerIdInterval.current = setInterval(repeatOften, idleSpeedCalc());
      }
    }
  }

  function log(txt, el = log1El) {
    // if (showDebug)
    //     el.current.innerHTML = txt;
  }

  function useMp4() {
    if (fileType !== "") {
      return fileType === "mp4";
    }

    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    let useMp4 = iOS || isIE11 || !MediaSource.isTypeSupported(vp9);
    return useMp4;
  }

  function useMsel() {
    if (msel !== "") {
      return !!+msel;
    }
    let use = isfireFoxMobile() || useMp4();
    return use;
  }

  function ppFunc(event) {
    //ppFunc1
    playPause(event.target.checked);
  }

  function setPlayPause() {
    playpauseEl.current.addEventListener("change", ppFunc);
  }

  function playPause(b) {
    if (b && !playerStarted.current) {
      if (r2p.preload) loadRest();
      if (r2p.preloadAll) startBinPlayer();
    }
    playpauseEl.current.checked = b;
    isMouseDown.current = !b;
    isPaused.current = !b;
  }

  function setUrlParams(props) {
    //console.log('---------------> getUrlParameter .isBin: ' + getUrlParameter('bin'))
    file = getUrlParameter("file");
    //isBin = getUrlParameter('bin') !== '' ? +getUrlParameter('bin') : props.isBin;
    gap =
      getUrlParameter("gap") !== ""
        ? +getUrlParameter("gap")
        : isfireFoxMobile()
        ? 0
        : 0.001;
    id1 = getUrlParameter("id1");
    id2 = +getUrlParameter("id2");
    compare = +getUrlParameter("compare");
    fileType = getUrlParameter("fileType");
    //debug = !!+getUrlParameter('_debug') && !isSecond.current;
    iOS =
      getUrlParameter("ios") !== ""
        ? +getUrlParameter("ios")
        : !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    msel = getUrlParameter("msel");
    disType = +getUrlParameter("disType");
    frameSeek = 1 / (+getUrlParameter("frameSeek") || 25);
    //isMobile = getUrlParameter('mobile') !== '' ? +getUrlParameter('mobile') : props.isMobile || /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    folder = getUrlParameter("folder") || "default";
    mime = getUrlParameter("mime");
    segment = +getUrlParameter("segment") || 256;

    setIdleSpeed();
    setMul();
  }

  function setMul() {
    const _multiplier = [];
    const mul = props.r2pData.multiplier;

    _multiplier[1] = mul
      ? mul[0]
      : +getUrlParameter("mul") || isMobile
      ? 0.2
      : 0.1;
    _multiplier[2] = mul
      ? mul[1]
      : +getUrlParameter("mul2") || isMobile
      ? 0.3
      : 0.2;
    _multiplier[3] = mul
      ? mul[2]
      : +getUrlParameter("mul3") || isMobile
      ? 0.4
      : 0.3;

    multiplier.current = _multiplier;
  }

  function setIdleSpeed() {
    const isp = r2p.idleSpeed || [];
    const _idleSpeed = [];
    _idleSpeed[1] = isp[0] || +getUrlParameter("idleSpeed") || 0.6;
    _idleSpeed[2] = isp[1] || +getUrlParameter("idleSpeed2") || 0.8;
    _idleSpeed[3] = isp[2] || +getUrlParameter("idleSpeed3") || 1;
    idleSpeed.current = _idleSpeed;
  }

  function setEvents() {
    if (isSecond.current) return;

    !r2p.isScrollPlay && setDebugMode();

    if (r2p.dblclick !== false && "ondblclick" in mask.current) {
      mask.current.addEventListener(
        "dblclick",
        (_) => {
          playpauseEl.current.click();
        },
        { passive: false }
      );
    } else {
    }

    r2p.isScrollPlay && window.addEventListener("scroll", handleScrollR2p);

    isTouch.current
      ? mask.current.addEventListener("touchend", endE, { passive: false })
      : window.addEventListener("mouseup", endE, { passive: false });
  }

  function setDebugMode() {
    if (location.hash === "#r2debug") {
      try {
        localStorage.setItem("r2debugShow", false);
      } catch (e) {
        console.error(e);
      }
    }
    if (r2debugShow() !== null) {
      //setDebugOn(r2debugShow())
      //setDebugTxt()
      //debugEl.current.style.display = r2debugShow() ? 'block' : 'none';
      !isTouch.current &&
        mask.current.addEventListener("click", showDebugTool, {
          passive: false
        });
      isTouch.current &&
        mask.current.addEventListener("touchstart", showDebugTool, {
          passive: false
        });
    }
  }

  let statrClick;
  let clicksNum = 0;
  let firstClickPauseStatus;

  function showDebugTool() {
    if (!statrClick || (statrClick && Date.now() > statrClick + 4000)) {
      statrClick = Date.now();
      firstClickPauseStatus = isPaused.current;
      clicksNum = 1;
    } else {
      ++clicksNum;
    }

    if (clicksNum === 3) {
      if (r2debugShow() !== null) {
        toggleDebugShow();
        isPaused.current = firstClickPauseStatus;
      }
    }
  }

  function toggleDebugShow() {
    try {
      localStorage.setItem("r2debugShow", !r2debugShow());
    } catch (e) {
      console.error(e);
    }
    setDebugOn(r2debugShow());
  }

  function r2debugShow() {
    try {
      return JSON.parse(localStorage.getItem("r2debugShow"));
    } catch (e) {
      console.error(e);
    }
  }

  function r2pJson(d) {
    const copy = { ...r2p };
    delete copy.PlayerSocket;
    delete copy.playerSync;
    const j = JSON.stringify(copy, null, 2);
    return j;
  }

  function setDebugPos(d) {
    if (psync.current.notifyImgNumber) {
      psync.current.notifyImgNumber(d.realPos);
    }
    debugEl.current &&
      (debugEl.current.querySelector(
        "." + s.pos
      ).innerText = `N: ${d.imgPos}, setN: ${d.realPos}`);
  }

  function setDebugTxt(data = {}) {
    if (debugEl.current) {
      const { realPos, imgPos } = _Bin.current;
      setDebugPos({ realPos, imgPos });
      debugEl.current.querySelector(
        ".sets"
      ).innerText = `${currentSet.current}/${setsNum.current}`;
      debugEl.current.querySelector(".ms").innerText = `${
        data.idle || parseInt(idleSpeedCalc())
      }`;
      debugEl.current.querySelector(
        ".images"
      ).innerText = `${playerLength.current}`;
    }
  }

  function throttle(callbackFn, limit) {
    let wait = false;
    return function () {
      if (!wait) {
        callbackFn.call();
        wait = true;
        setTimeout(function () {
          wait = false;
        }, limit);
      }
    };
  }

  const handleScrollR2p = useMemo((_) =>
    throttle(function handleScrollR2p(d = {}) {
      //console.log('roi2 handleScrollR2p')
      if (!contEl.current) {
        return;
      }
      const isInVP = isInViewport(contEl.current);

      if (isInVP) {
        inView.current = true;
      } else if (inView.current && !d.fromProp && isPlayerInit.current) {
        const newPosterKey = `${r2p.poster}${Date.now()}`;
        console.log(`roi2 player kill: ${r2p.canvasKey}`);
        props.setKey(newPosterKey);
        inView.current = false;
      }

      if (isOnTop.current && isInVP) {
        if (!isPlayerInit.current && !r2p.isMouseEnterPlay) {
          loadPlayer(isBase64, isBin);
        }
        isPaused.current =
          r2p.isMobile || d.fromProp
            ? false
            : !isInMiddleViewport(contEl.current);
      } else {
        isPaused.current = true;
      }
    }, 1000)
  );

  function isInViewport(element) {
    var rect = element.getBoundingClientRect();
    var html = document.documentElement;

    const isIn =
      rect.width > 0 &&
      rect.bottom >= 0 &&
      rect.top <= (window.innerHeight || html.clientHeight);
    return isIn;
  }

  function isInMiddleViewport(element) {
    var rect = element.getBoundingClientRect();
    var html = document.documentElement;
    const height = window.innerHeight || html.clientHeight;
    const maxView = 82;
    const middleLine = {
      top: height / 2 - maxView / 2,
      bottom: height / 2 + maxView / 2
    };
    const isIn =
      (parseInt(r2p.canvasKey) === 0 && rect.bottom > middleLine.top) ||
      (rect.bottom > middleLine.top && rect.top < middleLine.bottom) ||
      (rect.top < middleLine.bottom && rect.bottom > middleLine.top);
    return isIn;
  }

  function logDebug() {
    if (isCanvas.current) return;
    const du = video.buffered.length
      ? video.buffered.end(video.buffered.length - 1)
      : video.duration;
    log(
      "duration: " +
        du +
        ", index: " +
        currentIndex +
        ", time: " +
        _dics_[currentIndex],
      log2El
    );
  }

  function idleSpeedCalc() {
    if (msEdited.current) {
      return msEdited.current;
    }
    const roundInMiliSeconds = 21000;
    const TotalImages = 512;
    const idealSpeed = roundInMiliSeconds / TotalImages;
    const T =
      idealSpeed * 2 - idealSpeed / (TotalImages / playerLength.current);
    //console.log('images: ' + playerLength.current + ', T: ' + T);
    return T;
  }

  function slowDown(T) {
    inSlowDown = true;
    setTimeout((_) => {
      setDebugTxt({ idle: T });
      moveFrames({ from: "slowDown" });
      const nex = T + 2;
      if (nex < idleSpeedCalc()) {
        if (!isMouseDown.current) {
          slowDown(nex);
        } else {
          inSlowDown = false;
          inImp = false;
        }
      } else {
        setDebugTxt({ idle: parseInt(idleSpeedCalc()) });
        inSlowDown = false;
        inImp = false;
      }
    }, T);
  }

  let lastPos = 0;
  let lastDelta = 0;

  function setImptus() {
    window.imp = imp.current = new Impetus({
      source: mask.current,
      friction: 0.97,
      multiplier: multiplier.current[1],
      update: (x, y) => {
        if (x !== _x) {
          _direction.current = x < _x ? 1 : -1;
        }

        _delta = Math.abs(x - _x);

        if (lastDelta) {
          _delta += lastDelta;
          lastDelta = 0;
        }

        _x = x;
        // if (isSlow) {
        //     inImp = true;
        // }

        const mFrames = Math.floor(_delta);

        //console.log('mFrames: ' + mFrames + ', _x: ' + _x + ', x: ' + x + ', _delta: ' + _delta)

        if (isMouseDown.current && !mFrames) {
          lastDelta = _delta;
        } else if (isMouseDown.current || mFrames) {
          inImp = true;
          const calc = calcLastMove();
          if (Math.abs(lastCalcMove - calc) > 4) {
            //console.log('lastCalcMove: ' + lastCalcMove + ', calc: '  + calc)

            setDebugTxt({ idle: calc });
            lastCalcMove = calc;
          }
          moveFrames({ from: "Impetus", frames: mFrames });
        } else if (prevFrame > 0) {
          slowDown(20);
        }
        prevFrame = mFrames;
        lastX = x;
      }
    });
  }

  let lastMoveTime,
    lastCalcMove = 0;

  function calcLastMove() {
    if (!lastMoveTime) {
      lastMoveTime = Date.now();
    }
    const delta = Date.now() - lastMoveTime;
    lastMoveTime = Date.now();
    //console.log('T: -----: '  + delta)
    return delta;
  }

  function repeatOften() {
    if (_last_x === _x && !inSlowDown) {
      inImp = false;
    }

    !isMouseDown.current &&
      !isPaused.current &&
      !inImp &&
      moveFrames({ from: "idle" });

    _last_x = _x;

    if (currentSet.current < setsNum.current) {
      timerIdTimeout = setTimeout(repeatOften, idleSpeedCalc());
      lastSet.current !== currentSet.current && setDebugTxt();
      lastSet.current = currentSet.current;
    } else if (
      currentSet.current === setsNum.current &&
      !timerIdInterval.current
    ) {
      timerIdInterval.current = setInterval(repeatOften, idleSpeedCalc());
      setDebugTxt();
    }
  }

  function moveFrames({ from, frames = 1 }) {
    //console.log('from: ' + from)
    if (isCanvas.current) {
      drawImg.current({
        frames: frames * playerDirection.current * _direction.current
      });
      window.isPlayerOn = true;
      return;
    }
    // if (video.buffered.length === 0) {
    //     return;
    // }

    const du = video.buffered.length ? video.buffered.end(0) : 0;
    currentIndex =
      currentIndex + frames * playerDirection.current * _direction.current;

    if (currentIndex > _dics_.length - 1) {
      currentIndex = 0;
    } else if (currentIndex < 0) {
      currentIndex = _dics_.length - 1;
    }

    var toN = _dics_[currentIndex];
    var stoN = parseInt(toN) < 10 ? "&nbsp;" + toN : toN;
    log(
      "duration: " + du + ", index: " + currentIndex + ", time: " + stoN,
      log2El
    );
    log("move: " + from, log5El);
    logDebug();

    if (toN) video.currentTime = toN;

    if (window.rPlayer2) {
      window.rPlayer2.currentTime = toN;
    }
  }

  function endE(e) {
    document.body.style.userSelect = "";
    setDebugTxt();
    handDelay.current = false;
    //lastX = 0;
    isMouseDown.current = false;
    e.preventDefault();
  }

  function getFileExt(f) {
    f = f || getFile();
    const sp = f.split(".");
    const fileExt = sp[sp.length - 1];
    return fileExt;
  }

  function getFile() {
    var _file =
      file ||
      (useMp4()
        ? "SGM-Diamond-CRF16.PNG.H264.DASH.FKF128.SEG64.FPS25.3PartsMerged.128.128.256.mp4"
        : "SGM-Diamond-CRF30.PNG.VP9.DASH.G4.SEG64.FPS25.3PartsMerged.128.128.256.webm");
    return _file;
  }

  function getNextPartUrl() {
    var f = getFile();
    const init = "init." + getFileExt(f);

    const d = {
      url:
        `https://ion.r2net.com/images/player/Media/${folder}/` +
        (getN === 0 ? init : getN + "_" + f),
      N: getN
    };
    getN++;
    return d;
  }

  function startPlayer(_video) {
    video = _video || video;
    const cw = video.closest(".c-wrap");
    if (cw) {
      video.closest(".c-wrap").style.zIndex = 2002;
    }

    if (isSecond.current) {
      return;
    }

    setImptus();
    repeatOften();
  }

  function _showLoader(show) {
    setShowLoader(show);
  }

  function setLoadedData(N, L) {
    currentSet.current = N;
    playerLength.current = L;
    setDebugTxt();
    //setProg(100 / r2p.preloadNum * (currentSet.current + 1))
  }

  function updateBinPlayer(N, L) {
    if (r2p.isMobile) {
      if (currentSet.current === 3) {
        updateN.current = 2;
      }
    } else {
      if (currentSet.current == 5) {
        updateN.current = 2;
      } else if (currentSet.current == 8) {
        updateN.current = 3;
      }
    }

    imp.current.setMultiplier(multiplier.current[updateN.current]);
    //setProg(100 / setsNum.current * (currentSet.current + 1))
  }

  function firstPhaseLoaded() {
    loadPhase.current = 1;
    if (handClicked.current) {
      loadRest();
    }

    if (r2p.autoplay) {
      setShowLoader(false);
    } else {
      rpProgressEl.current && rpProgressEl.current.classList.add(s["loaded"]);
      setTimeout(() => {
        setShowLoader(false);
        isShowFinger() && setShowFinger(true);
      }, 500);
    }
  }

  function isShowFinger() {
    return (
      !r2p.hideFinger &&
      !~window.fingerShowed.indexOf(r2p.urlFormat) &&
      getFinger() < 2 &&
      !playerStarted.current
    );
  }

  function getFinger() {
    try {
      return +localStorage.getItem("r2p-finger");
    } catch (e) {
      console.error(e);
    }
  }

  function incrementFinger() {
    try {
      localStorage.setItem("r2p-finger", getFinger() + 1);
    } catch (e) {
      console.error(e);
    }
  }

  function startBinPlayer(N, L) {
    mask?.current?.removeEventListener?.(
      isTouch.current ? "touchstart" : "mousedown",
      startBinPlayer
    );
    pushGTMExtraData({
      eventName: "360 interactions",
      eventText: "N/A",
      eventDetail: "rotated",
      eventGroup: "item interactions",
      extraEventDetails: {
        item_id: r2p.itemID
      }
    });
    setShowFinger(false);
    window.fingerShowed.push(r2p.urlFormat);
    playerStarted.current = true;
    const cw = canvasEl.current.closest(".c-wrap");
    if (cw) {
      canvasEl.current.closest(".c-wrap").style.zIndex = 2002;
    }

    if (isSecond.current) {
      return;
    }

    repeatOften();
    _showLoader(false);

    //debugEl.current.style.display = 'block';

    //ssetProg(100 / r2p.preloadNum * (currentSet.current + 1))
    //setProg(100 / setsNum.current * (currentSet.current + 1))
  }

  function checkWarnings(width, height) {
    if (
      canvasEl.current.offsetWidth / canvasEl.current.offsetHeight !==
      width / height
    ) {
      debugEl.current.querySelector(".warn-txt").innerText =
        "warning NO.552871 render mismatch";
      debugEl.current.querySelector(".warn").style.display = "block";
    }
  }

  function updatePlayer(_video, _partN) {
    video = _video || video;
    partN = _partN || getN;
    if (partN == 8) {
      if (isSecond.current) {
        window.rPlayer2 = video;
        return;
      }
      movedTo = 3;
      updateN.current = 3;
      var io = dics3.indexOf(dics2[currentIndex]);
      currentIndex = io;
      _dics_ = dics3;
    } else if (partN == 4) {
      movedTo = 2;
      updateN.current = 2;
      var io = dics2.indexOf(dics1[currentIndex]);
      currentIndex = io;
      _dics_ = dics2;
    }
  }

  const imageRendering = !!~r2p.poster.indexOf("/sets/Jewelry/Rings/")
    ? s.imageRendering
    : "";
  const _width = r2p.width;
  const ratio = _width && r2p.height ? `${(r2p.height / _width) * 100}%` : null;
  const flexMiddleStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };

  const Img = ({ src = "" }) => {
    return (
      <img
        crossOrigin="anonymous"
        {...(r2p.alt ? { alt: r2p.alt } : {})}
        {...(props.dataQA ? { "data-qa": props.dataQA } : {})}
        ref={src ? imgbgEl : imgHideEl}
        src={src}
        style={{ verticalAlign: "middle", width: `${100 + scale}%` }}
        className={imageRendering}
      />
    );
  };

  const Slider = r2p.isBn ? BnSlider : R2pSlider;

  const renderBNMouseImageCover = () => {
    const mask = `${s.mask} ${isMobile ? s.mobile : ""}`;

    const MaskSVG = isMobile ? TouchMaskBNSVG : MouseMaskBNSVG;

    return (
      <div className={mask} data-qa="click-and-drag-animation">
        <MaskSVG />
        <div className={s.subTitle}>
          {isMobile ? "Touch & Drag to rotate" : "Click & drag to rotate"}
        </div>
      </div>
    );
  };

  const renderJAMouseImageCover = () => {
    const mask = `${s.maskJA} ${isMobile ? s.mobile : ""}`;

    const MaskSVG = isMobile ? TouchMaskJASVG : MouseMaskJASVG;

    return (
      <div className={mask} data-qa="click-and-drag-animation">
        <div className={s.maskOverlay} />
        <MaskSVG />
        <div className={s.subTitle}>
          {isMobile ? "Touch & Drag to rotate" : "Click & drag to rotate"}
        </div>
      </div>
    );
  };
  const handMask = r2p?.isBn
    ? renderBNMouseImageCover()
    : renderJAMouseImageCover();

  return (
    <div
      data-t="1"
      {...(r2p.dataQa ? { "data-qa": `${r2p.dataQa}-player` } : {})}
      className={`r2p-container ${r2p.containerClass || ""} ${
        r2p.isBn ? s["isBn"] : ""
      }`}
      ref={contEl}
      style={{
        backgroundColor: r2p.bgColor || "",
        position: "relative",
        height: 0,
        paddingBottom: ratio,
        maxWidth: "100%",
        width: "100%"
      }}
      data-debug={+getUrlParameter("_debug") ? "true" : "false"}
    >
      {r2p.icon && (
        <i>
          {r2p?.isBn ? (
            <BnIcon
              style={{
                width: isPair ? 15 : 30,
                bottom: isPair ? 9 : 14,
                right: isPair ? 11 : 22
              }}
            />
          ) : (
            <JaIcon
              style={{
                width: 30,
                bottom: 14,
                right: 22
              }}
            />
          )}
        </i>
      )}
      {showLoader &&
        (r2p.autoplay ? (
          <div className={s["r2p-loader"]}>
            <Loader />
          </div>
        ) : (
          <div ref={rpProgressEl} className={`${s["rp-progress"]}`}></div>
        ))}
      <div ref={canvasContainerEl} style={flexMiddleStyle}>
        {!r2p.hidePoster && (
          <div
            ref={imgBgContainerEl}
            className={s.imgBgContainer}
            style={flexMiddleStyle}
          >
            <Img src={poster} />
            <div style={{ display: "none" }}>
              <Img />
            </div>
          </div>
        )}
        <canvas
          height={r2p.height}
          width={r2p.width}
          style={{
            position: "relative",
            width: `${100 + scale}%`,
            display: "block"
          }}
          ref={canvasEl}
          aria-label={r2p.canvasAriaLabel}
          className={`${s.pcanvas} ${imageRendering}`}
        ></canvas>
        {!r2pData.hide360 && (
          <i
            ref={i360El}
            className={`${s["i-360"]} ${
              r2p.containerWidth === 630 ? s.big360 : ""
            }`} 
             style={{
              "--logo-width":
                r2p.width === 303 ? "60px" :
                "120px"
            }}
          ></i>
        )}
        {!isSecond.current && (
          <div ref={playerMaskEl} className={s["player-mask"]}></div>
        )}
      </div>
      <div style={{ pointerEvents: showLoader ? "none" : "auto" }}>
        {!isMobile && !r2pData.hideZoom && (
          <Slider
            player={canvasContainerEl}
            playerSocket={r2p.PlayerSocket}
            psync={psync}
            setSliderPosFunc={setSliderPosFunc}
            setShowSliderFunc={setShowSliderFunc}
            init={r2p?.slider}
            r2p={r2p}
          />
        )}
      </div>
      {showFinger && handMask}
      {!isMobile && !isSecond.current && (
        <div style={{ display: "none" }} className={s.dupli} ref={dupliEl}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path d="M22 6v16h-16v-16h16zm2-2h-20v20h20v-20zm-24 17v-21h21v2h-19v19h-2z" />
          </svg>
        </div>
      )}
      {!debugOn && (
        <input
          ref={playpauseEl}
          style={{ display: "none" }}
          type="checkbox"
          defaultChecked
          value="None"
          id={ppId}
          name="check"
        />
      )}
      {debugOn &&
        createPortal(
          <div
            className={`${s.debug_b} ${r2p.isMobile ? s.mob : ""}`}
            ref={debugEl}
          >
            <div className={`warn ${s.warn}`}>
              <span className="warn-txt"></span>
            </div>
            <img
              onClick={toggleDebugShow}
              className={s.close}
              src={"https://ion.r2net.com/images/player/_close1.svg"}
            />
            <div className={s.posContainer}>
              <label className={s.label2} htmlFor={ppId}></label>
              <div className={s.playpause}>
                <input
                  ref={playpauseEl}
                  type="checkbox"
                  defaultChecked={!isPaused.current}
                  value="None"
                  id={ppId}
                  name="check"
                />
                <label htmlFor={ppId}></label>
              </div>
              <div className={s.pos}></div>
            </div>
            <div className={s.load}>
              <span> sets: </span>
              <span className="sets"></span> |<span> ms: </span>
              <span
                style={{ display: "inline-block", minWidth: "17px" }}
                onInput={debugChange}
                contentEditable
                className="ms"
              ></span>{" "}
              |<span> images: </span>
              <span className="images"></span>
            </div>
            <pre className={s.r2p}>{r2pJson()}</pre>
          </div>,
          document.body
        )}
    </div>
  );
};

export const VideoPlayer = memo(
  (props) => {
    const r2p = props.r2pData;
    var [key, setKey] = useState(r2p.poster);

    if (key !== r2p.poster) {
      r2p.holdLoad = true;
    }
    return <VideoPlayerComp key={key} {...props} setKey={setKey} />;
  },
  (prev, next) => {
    return prev.isOnTop === next.isOnTop;
  }
);
